import _ from 'lodash';
import { convertToObjects } from '@/main/utils/table';
import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY, COLUMN_HOD_SZB, COLUMN_GAR_SZB, COLUMN_INTERNAL_HOURLY_RATE } from '../constants';
import { listMutations, listActions } from './types';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		VyrobekvozOzn: [],
		StrnakltypOzn: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		VyrobekvozOzn: null as string | null,
		Tablpozice: null as string | null,
		TablpoziceText: null as string | null,
		StrnakltypOzn: null as number | null,
		StrednaklOzn: null as number | null,
		StrednaklOznText: null as string | null,
	},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			[COLUMN_HOD_SZB]: { isEditable: true, required: true },
			[COLUMN_GAR_SZB]: { isEditable: true, required: true },
			[COLUMN_INTERNAL_HOURLY_RATE]: { isEditable: true, required: true },
		},
	},
	rowDetail: null,
	localState: {
		hodSzb: null as number | null,
		garSzb: null as number | null,
		internalHourlyRate: null as number | null,
		loadingSazbyZaklad: false as boolean | null,
	},
	extraActions: {
		[listActions.UPDATE_TABLE_COLUMN]: ({ commit }, data) => commit(listMutations.UPDATE_TABLE_COLUMN, data),
		[listActions.SAVE_TABLE]: async ({ state, commit }) => apiProvider.saveTable(convertToObjects(state.table)),
	},
	extraMutations: {
		[listMutations.TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.filter.Tablpozice = data.value;
			state.filter.TablpoziceText = data.text;
		},
		[listMutations.NAKLADOVE_STREDISKO_SELECT_MAPPER](state, { data }) {
			state.filter.StrednaklOzn = data.value;
			state.filter.StrednaklOznText = data.text;
		},
		[listMutations.UPDATE_TABLE_COLUMN](state, { columnName, value }) {
			const updatedColumn = state.table.columns.find((column) => column.columnName === columnName);
			const columnIndex = parseInt(updatedColumn!.columnId, 10);
			state.table.rows.forEach((row) => {
				row.cells[columnIndex] = value;
			});
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
